// The annual cards always include the current Thai fiscal year, even when
// the API has no row for it yet. October starts the following fiscal year.
export const completeMetricYears = (stats = [], now = new Date(), serverFiscalYear) => {
    const fiscalYear = Number(serverFiscalYear) || now.getFullYear() + (now.getMonth() >= 9 ? 1 : 0) + 543;
    const values = new Map(stats.map((stat) => [Number(stat.label), stat.value]));
    return [fiscalYear - 2, fiscalYear - 1, fiscalYear].map((year) => ({
        label: String(year),
        value: values.get(year) ?? "0",
    }));
};
